module.exports = __webpack_public_path__ + "img/product3.966b0eed.png";